module.exports = __webpack_public_path__ + "static/media/whatsdown_schriftzug.8dd3ac54.svg";